var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 25,
    height: 25,
    rx: 4.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.4H18.6C20.2 13.4 21 12.6 21 11V9.4C21 7.8 20.2 7 18.6 7H17C15.4 7 14.6 7.8 14.6 9.4V11C14.6 12.6 15.4 13.4 17 13.4ZM7.4 23H9C10.6 23 11.4 22.2 11.4 20.6V19C11.4 17.4 10.6 16.6 9 16.6H7.4C5.8 16.6 5 17.4 5 19V20.6C5 22.2 5.8 23 7.4 23ZM8.2 13.4C9.04869 13.4 9.86263 13.0629 10.4627 12.4627C11.0629 11.8626 11.4 11.0487 11.4 10.2C11.4 9.35131 11.0629 8.53737 10.4627 7.93726C9.86263 7.33714 9.04869 7 8.2 7C7.35131 7 6.53737 7.33714 5.93726 7.93726C5.33714 8.53737 5 9.35131 5 10.2C5 11.0487 5.33714 11.8626 5.93726 12.4627C6.53737 13.0629 7.35131 13.4 8.2 13.4ZM17.8 23C18.6487 23 19.4626 22.6629 20.0627 22.0627C20.6629 21.4626 21 20.6487 21 19.8C21 18.9513 20.6629 18.1374 20.0627 17.5373C19.4626 16.9371 18.6487 16.6 17.8 16.6C16.9513 16.6 16.1374 16.9371 15.5373 17.5373C14.9371 18.1374 14.6 18.9513 14.6 19.8C14.6 20.6487 14.9371 21.4626 15.5373 22.0627C16.1374 22.6629 16.9513 23 17.8 23Z",
    stroke: "#2E732F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableMenu);
export default __webpack_public_path__ + "static/media/TableMenu.7759ee5b6890a6f400cf6207d9d7411b.svg";
export { ForwardRef as ReactComponent };